<div class="pt-safe-top pb-safe-bottom">
  <div class="min-h-screen min-w-full bg-blue-900 z-50 fixed" >
    <ng-content></ng-content>
  </div>
</div>
